import React, { useEffect, useState } from "react";
import styles from "./YourMarketingPlan.module.css";
import { ReadProSubscriptionDetails } from "../../Components/mockData";
import { Link } from "react-router-dom";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import AutoPayDetailsContent from "../AutoPayDetailsContent/AutoPayDetailsContent";
import { useHistory } from "react-router";
import { creditHistory, readOrderHistory, recurringOrders } from "../../Services/pgi";
import { connect } from "react-redux";
import { getFormattedDate } from "../../Values/utils";


interface ListItem {
  label: string;
  date: string;
  amount: string;
}

interface MarketingPlan {
  title: string;
  totalBalance: string;
  list: ListItem[];
  splTxt?: string;
}

interface YourMarketingPlanProps { 
  user?:any
}


const YourMarketingPlan: React.FC<YourMarketingPlanProps> = ({user}) => {
  const [autoPayDetails, setAutoPayDetails] = useState<boolean>(false);
  const history = useHistory();
  const [data, setData] = useState<any[]>([]);
  // const [loading, setLoading] = useState(true);
  const serviceIds = ["13739",'13780'];
  const soId = user?.user_super_oid;
  const [pageNo, setPageNo] = useState('1');
  const [nextPageAvailable, setNextPageAvailable] = useState(false);
  const [totalBalance, setTotalBalance] = useState("0");
  const [exPackage, setExPackage] = useState();
  const [time, setTime] = useState();
  const [item, setItem] = useState<any>();
  const [days, setDays] = useState<any>();
  const [alert, setAlert] = useState(false);
  const [orderData, setOrderData] = useState<any>([]);
      // console.log("exPackage",exPackage)
      // console.log("time",time)

  const autoPayDetailsHandler = () => {
    setAutoPayDetails(true);
    document.body.classList.add("no-overflow");
  }
//   const fetchOrders = async () => {
//     try {
//         const ordersList = await recurringOrders(user.user_super_oid,serviceIds);

//         const validOrders = ordersList.data.filter((order: { success: any }) => order.success === true);

//         console.log("validOrders", validOrders);
//         setOrderData(validOrders);
//     } catch (error) {
//         console.error("Error fetching orders:", error);
//     }
// };


const fetchOrders = async () => {
  try {
      const ordersList = await recurringOrders(user.user_super_oid, serviceIds);

      if (!ordersList || !ordersList) {
          console.error("Error: ordersList or ordersList.data is undefined");
          return;
      }

      const validOrders = ordersList.filter((order: { success: any }) => order.success === true);

      setOrderData(validOrders);
  } catch (error) {
      console.error("Error fetching orders:", error);
  }
};

   useEffect(() => {
    fetchOrders();
}, [user.user_super_oid]);



  useEffect(() => {
   const fetchHistory = async () => {
              try {
                  // setLoading(true);
                  // const data = await readOrderHistory(serviceIds, soId, pageNo,(data: any) => setNextPageAvailable(data),true);
                  const data =await creditHistory(serviceIds,soId,(data: any) => setTotalBalance(data),(data: any) => setExPackage(data),(data: any) => setTime(data))
                  // console.log("dataaaaaa",data)
                  setData(data);
                  // setLoading(false);
              } catch (error) {
                  console.error("Error fetching history:", error);
                  // setLoading(false);
              }
          };
          fetchHistory();

    }, [user]);
// console.log("data Your Plan",data)

const checkAlerts = (data:any) => {
const today = new Date(); // Get today's date
const sevenDaysLater = new Date();
sevenDaysLater.setDate(today.getDate() + 6); // Calculate 7 days from today

let minDays = Infinity; // Initialize with a very large number
let alert = false; // Initialize alert flag

data.forEach((item:any) => {
  const orderEndDate = new Date(item.orderEndDate); // Parse orderEndDate

  // Ensure orderEndDate is a valid date
  if (isNaN(orderEndDate.getTime())) {
    // console.error("Invalid orderEndDate:", item.orderEndDate);
    return;
  }

  // Check if the orderEndDate is within the next 7 days
  if (orderEndDate >= today && orderEndDate <= sevenDaysLater) {
    alert = true; // Set alert to true if condition matches
  }

  // Calculate days remaining and update minDays
  if (orderEndDate >= today) {
    const daysRemaining = Math.ceil(
      (orderEndDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24) // Convert milliseconds to days
    );
    minDays = Math.min(minDays, daysRemaining);
  }
});

setAlert(alert)
setDays(minDays)
};


const transformData = (data:any) => {
  // const firstThreeObjects = data.slice(0, 3);

  let totalBalance = 0;
  const list = data.map((item:any) => {
    const amount = item.packageCredit - item.totalUnitUsed;
    totalBalance += amount;

    return {
      label: item.packageName,
      date: getFormattedDate(item.orderDate),
      amount: amount.toString(),
    };
  });

  return [
    {
      title: "Whatsapp",
      totalBalance: totalBalance.toString(),
      list,
      splTxt: "1 pack expiring in 7 days",
    },
  ];
};
useEffect(()=>{
  const finalData = transformData(data)
  setItem(finalData)
  checkAlerts(data)
   },[data])
  return (
    <>
      <div className={styles.YourMarketingPlansWrap}>
        <div className={styles.Frame}>
          <span className={styles.YourMarketingPlans}>
            Your Marketing Plans
          </span>
          <span className={styles.ctaOutlined}
           onClick={() => {
                history.push("/rechargeTransactionHistory");
              }} >Recharge History</span>
        </div>
        <div className={styles.YourMarketingPlnCards}>
          {item?.map((item: MarketingPlan, index: number) => {
            
            if(item.title === "Whatsapp"){ return (
              <div
                className={`${styles.MarketingPlanCard} ${item.title === "Whatsapp"
                  ? styles.Whatsapp
                  : item.title === "E Mail"
                    ? styles.Email
                    : item.title === "SMS"
                      ? styles.Sms
                      : ""
                  }`}
                key={index}
              >
                <div className={styles.MarketingPlanCardTp}>
                  <span className={styles.MarketingPlanCardTitle}>{item.title}</span>
                  <span className={styles.TotalBalance}>
                    Total Balance
                    <span className={styles.textstyle2}>
                      <span className={styles.Rupees}>₹</span> {totalBalance}
                    </span>
                  </span>
                </div>
                <div className={styles.MarketingPlanCardList}>
                  {
                    (item?.list.length!==0) ?  
                    <>
                      {item?.list.map((list, index) => {
                        return (
                          <div className={styles.MarketingPlanCardListRow} key={index}>
                            <span className={styles.MarketingPlanCardListValue}>{list.label}</span>
                            <span className={styles.MarketingPlanCardListValue}>{list.date}</span>
                            <span className={styles.MarketingPlanCardListValue}>
                              <span className={styles.Rupees}>₹ </span>
                              {list.amount}
                            </span>
                          </div>
                        );
                      })}
                    </>
                    :
                    <div className={styles.MarketingPlanCardListNoactivePlan}>
                        No Active Plan
                    </div>
                  }
                  {/* {item?.list.length > 2 && 
                  <span className={styles.SeeAll} 
                  onClick={() => {
                    history.push({
                      pathname:"/rechargeTransactionHistory",
                      state: { succes: true },
                    });
                  }}
                  >See All</span>} */}
                </div>
                <div className={styles.MarketingPlanCardActn}>
                    
                    {(alert && (time && time>0)) && <span className={styles.MarketingPlanSplTxt}>{`${exPackage} pack expiring in ${time} ${(time &&time>1)?"days":(time==1)?"day":""}`}</span>}
                    {item.title === "Whatsapp" && 
                    <>
                    {orderData.length>0 && <Link to={'/whatsappRechargePlans'} className={styles.ctaOutlined}>Autopay Details</Link>}
                    <Link to={'/whatsappRechargePlans?type=recharge-plans'} className={styles.ctaFilled}>{alert ?"Recharge Now":"Recharge"}</Link>
                    </>}
                  {/* {item?.title === "E Mail" && (
                    <>
                      <span className={styles.ctaOutlined} onClick={autoPayDetailsHandler}>Autopay Details</span>
                      <Link to={'/emailRechargePlans'} className={styles.ctaFilled}>Topup</Link>
                    </>
                  )}
                  {item?.title === "SMS" && <span className={styles.ctaOutlined}>Recharge</span>} */}
                </div>
              </div>
            );}
          })}
        </div>
      </div>
      {
        autoPayDetails &&
        <CenteredPopUp
          setModal={setAutoPayDetails}
          children={
            <AutoPayDetailsContent
              setAutoPayDetails={setAutoPayDetails}
            />
          }
          modiferClass={styles.Tabp}
          closeIcon={false}
        />
      }
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(YourMarketingPlan);
// export default YourMarketingPlan;
